/** Shared time filter types and date utilities for SAB PTS time windows. */

import { todayET, addDaysToBareDate } from '@/lib/etDate';

export type PointsTimeFilter = '7d' | '14d' | '30d' | 'season';

export const TIME_FILTER_OPTIONS: { value: PointsTimeFilter; label: string }[] = [
  { value: '7d', label: '7D' },
  { value: '14d', label: '14D' },
  { value: '30d', label: '30D' },
  { value: 'season', label: 'Season' },
];

// SAB-793: todayET now lives in @/lib/etDate — this file held the one CORRECT copy of
// the idiom while six other spellings of it were live elsewhere.

/**
 * Returns { start, end } date strings for the given time filter.
 * Returns null for 'season' (no date filtering needed).
 */
export function getDateRange(filter: PointsTimeFilter): { start: string; end: string } | null {
  if (filter === 'season') return null;
  const days = filter === '7d' ? 7 : filter === '14d' ? 14 : 30;
  const end = todayET();
  // Pure string arithmetic — no Date is parsed, so no runtime zone can shift the window.
  // The old form anchored at LOCAL noon and then called .toISOString(), which holds only
  // for offsets within roughly ±12h of UTC.
  const start = addDaysToBareDate(end, -days);
  return { start, end };
}
